// components.application.integrations.connectIntegrationModal.addApplication

import oAuth from './oAuth';

export default {
  title: '',
  description: '',
  oAuth
};
